import {
  ILibraryContentItemType,
  IUserLibraryEntitiesParameters,
} from '@ifit/gateway-wolf-athenaeum-service';

export function applyChallengeToIncludedEntities(
  applied: Partial<IUserLibraryEntitiesParameters>,
  doEnableChallengeStore: boolean,
): Partial<IUserLibraryEntitiesParameters> {
  if (
    doEnableChallengeStore &&
    applied.includedEntities?.includes(ILibraryContentItemType.Program)
  ) {
    applied.includedEntities = [
      ...applied.includedEntities,
      ILibraryContentItemType.Challenge,
    ];
  }
  return applied;
}
